import { i as p, x as l, n as u, T as v, a as g } from "../separate-component-helper-chunks/abstract-base-xBS_db8B.js";
import { o as a } from "../separate-component-helper-chunks/if-defined-CfkW11V1.js";
import { l as c } from "../separate-component-helper-chunks/live-rg_JtnMg.js";
import { B as y } from "../separate-component-helper-chunks/form-base-BjmCAmbT.js";
import { B as $ } from "../separate-component-helper-chunks/beacon-primitive-ChVMWFlW.js";
import { b as w } from "../separate-component-helper-chunks/query-assigned-DFUTWPNn.js";
const t = {
  defaultTime: "T00:00:00",
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
}, x = p`label,.label{font-size:var(--beacon-form-label-font-size);font-weight:var(--beacon-form-label-font-weight);line-height:var(--beacon-form-label-font-line-height);margin:0;padding:0}.hint{font-size:var(--beacon-form-font-size);line-height:var(--beacon-form-font-line-height);margin:0}input,select,textarea{color:var(--beacon-form-field-color-text-default)}[aria-disabled=true]{caret-color:transparent;color:var(--beacon-form-field-color-text-inactive);cursor:not-allowed}input{--border-color: var(--beacon-form-field-color-border-default);--border-size: var(--beacon-form-field-size-border-width-default);--font-color: var(--beacon-form-field-color-text-default);background-color:var(--beacon-form-field-color-background);block-size:var(--beacon-form-field-size-block);border:var(--border-size) solid var(--border-color);border-radius:var(--beacon-form-field-size-border-radius);color:var(--font-color);font-size:var(--beacon-form-font-size);inline-size:var(--beacon-custom-form-field-inline-size, 100%);line-height:var(--beacon-form-font-line-height);margin-block-start:var(--beacon-custom-form-field-space-margin-block-start, var(--beacon-form-field-space-margin));margin-inline-start:0;padding-inline:var(--beacon-form-field-space-padding)}:is(input.error,input.error:focus){--border-size: var(--beacon-form-field-size-border-width-error);--border-color: var(--beacon-form-field-color-border-error)}input:not([type=date]).error{--font-color: var(--beacon-form-field-color-text-error)}input:not([type=date]).error:focus{--font-color: var(--beacon-form-field-color-text-default)}:host([icon-position]) input{background-image:var(--input-field-icon, none);background-position:var(--input-icon-position, none);background-repeat:no-repeat}:host([icon-position=left]){--input-icon-position: var(--beacon-form-icon-space-position-inline-start)}:host([icon-position=left]) input:not([type=date]){padding-inline-start:var(--beacon-form-icon-space-padding)}:host([icon-position=right]){--input-icon-position: var(--beacon-form-icon-space-position-inline-end)}:host([icon-position=right]) input:not([type=date]){padding-inline-end:var(--beacon-form-icon-space-padding)}:host input[type=date]{align-content:center;display:grid}input:focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc( var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) );outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus));outline-offset:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal));position:relative;z-index:1}:host([icon-position]) input{display:flex}:host([icon-position=left]) input[type=date]{flex-direction:row-reverse;gap:calc(.75 * var(--beacon-unit-base))}`;
var z = Object.defineProperty, f = (h, e, o, r) => {
  for (var i = void 0, d = h.length - 1, m; d >= 0; d--)
    (m = h[d]) && (i = m(e, o, i) || i);
  return i && z(e, o, i), i;
};
const b = "beacon-date-picker", k = ["beacon-error"], s = class s extends $(y) {
  constructor() {
    super(...arguments), this.beaconTagName = b, this.focusOverride = !0, this.name = "date-picker";
  }
  static get styles() {
    return [super.styles, x];
  }
  minValidation() {
    var e;
    if (this.value && this.min && typeof this.min == "string" && this.value < this.min) {
      const { defaultTime: o } = t, r = (/* @__PURE__ */ new Date(`${this.min}${o}`)).toLocaleDateString(void 0, {
        year: t.year,
        month: t.month,
        day: t.day
      }), i = this.errorsMap.min || ((e = this.defaultMessages.minDate) == null ? void 0 : e.replace("%X%", r));
      this.setValidity({ rangeUnderflow: !0 }, i);
    }
  }
  maxValidation() {
    var e;
    if (this.value && this.max && typeof this.max == "string" && this.value > this.max) {
      const { defaultTime: o } = t, r = (/* @__PURE__ */ new Date(`${this.max}${o}`)).toLocaleDateString(void 0, {
        year: t.year,
        month: t.month,
        day: t.day
      }), i = this.errorsMap.max || ((e = this.defaultMessages.maxDate) == null ? void 0 : e.replace("%X%", r));
      this.setValidity({ rangeOverflow: !0 }, i);
    }
  }
  render() {
    var e, o;
    return this.invalid = !((e = this.internals) != null && e.checkValidity()), l` <label for=${this.id}>${this.label}</label>
      ${this.hint ? l`<p class="hint" id="hint">${this.hint}</p>` : l``}
      ${this.invalid ? u`<${this.getScopedTag("beacon-error")} message="${(o = this.internals) == null ? void 0 : o.validationMessage}" id="error"></${this.getScopedTag(
      "beacon-error"
    )}>` : v}
      <input
        type="date"
        title=${a(this.title)}
        id=${this.id}
        aria-describedby="${a(
      this.hint || this.invalid ? [this.hint ? "hint" : "", this.invalid ? "error" : ""].join(" ").trim() : void 0
    )}"
        aria-invalid=${c(this.invalidStateAsString)}
        aria-disabled=${c(this.disabledStateAsString)}
        class="${this.invalid ? "error" : ""} form-anchor"
        name=${this.name}
        min=${a(this.min)}
        max=${a(this.max)}
        .value=${c(this.value)}
        ?required=${this.required}
        ?invalid=${this.invalid}
        @input=${this.handleInput}
        @blur=${this.handleBlur}
        @keydown=${this.handleKeydown}
        @mousedown=${this.handleMousedown}
        @change=${this.emitChange}
      />`;
  }
};
s.tagName = b, s.nestedComponents = k;
let n = s;
f([
  g({ reflect: !0 })
], n.prototype, "name");
f([
  w("input#date-picker")
], n.prototype, "input");
export {
  n as BeaconDatePicker
};
